<template>
    <div
        @click="!loading && onClick($event)"
        class="pos_close"
        :class="{ 'ppv2-opacity-50 ppv2-pointer-events-none': loading }"
        :style="{ gap: normalizeSize(18), right: normalizeSize(50, true) }"
    >
        <span v-if="loading" class="ppv2-flex ppv2-items-center">
            <svg
                class="ppv2-animate-spin ppv2-h-4 ppv2-w-4 ppv2-text-[#505d92]"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
            >
                <circle class="ppv2-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path
                    class="ppv2-opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>
        </span>
        <X v-else color="#505d92" :size="20" />
        <span class="ppv2-text-black ppv2-text-opacity-70" :style="{ fontSize: normalizeFontSize(16) }">
            {{ label }}
        </span>
    </div>
</template>

<script>
import { X } from 'lucide-vue'
import normalizeSize from '../../utils/normalizeSize'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'CustomButtonSave',
    components: { X },
    props: {
        label: {
            type: String,
            default() {
                return this.$t ? this.$t('experience.btnSaveAndLeave') : 'Enregistrer et quitter'
            },
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        onClick(event) {
            this.$emit('click', event)
        },
    },
}
</script>

<style scoped>
.pos_close {
    position: absolute;
    top: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;
}
</style>
